import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import get from 'lodash/get';
import { fetchSkill } from '../store/slices/skillSlice';

export const useSkill = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.skill);

  useEffect(() => {
    dispatch(fetchSkill({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', []),
    loading: get(findAll, 'loading', false)
  };
};
